import React from 'react'
import PropTypes from 'prop-types'

import { SegueLink } from "app/static/frontend/middleware/segueMiddleware"

import { renderText } from 'search-new/components/Inline/shared/functions'
import { stringContainsHTMLMarkup } from 'shared/imports/sharedHelperFunctions'

const InlineBills = (props) => {
    const renderBillTitle = (billTitle) => {
        if (stringContainsHTMLMarkup(billTitle)) {
            return renderText({
                lineData: billTitle,
                isHtml: true,
                inlineId: props.inlineId,
                isSearchify: false,
            })
        }

        return billTitle
    }

    const renderBill = bill => (
        <div key={`${bill.label}|${bill.title}`} className="label label-hyperlink">
            <b>
                <object>
                    <SegueLink
                        onClick={(e) => { e.stopPropagation() }}
                        to={`/bill/${bill.id}`}
                        href={`/bill/${bill.bd}`}
                    >
                        {
                            `${DjangIO.app.models.Region.by_value(bill.region).abbrev.toUpperCase()}` +
                            ` ${bill.label}: `
                        }
                        {renderBillTitle(bill.title)}
                    </SegueLink>
                </object>
            </b>
        </div>
    )

    if (props.bills && props.bills.length) {
        return (
            <div className="inline-bills">
                {
                    props.bills.map(bill => (
                        renderBill(bill)
                    ))
                }
            </div>
        )
    } else if (props.bill) {
        return (
            <div className="inline-bill">
                {renderBill(props.bill)}
            </div>
        )
    }

    return undefined
}

InlineBills.propTypes = {
    bill: PropTypes.object,
    bills: PropTypes.arrayOf(PropTypes.object),
    inlineId: PropTypes.number,
}

export default InlineBills
